<div class="d-flex justify-content-between ">
    <mat-toolbar color="primary" class="header-container">
        <mat-toolbar-row>
            <a href="/" aria-label="Home">
                <img height="35" src="/assets/images/logo-noovle.svg" alt="Logo Noovle">
            </a>
            <span class="menu-spacer"></span>
            <div class="menu-links">
                <a mat-button [routerLink]="'/requests'" [routerLinkActive]="'active'" class="mx-2"><span
                        [matBadge]="requestCount" matBadgeSize="small" matBadgeOverlap="false">{{'REQUEST.MY_REQUESTS' |
                        translate}}</span></a>
                <a mat-button [routerLink]="'/actions'" [routerLinkActive]="'active'" class="mx-2" *ngIf="getVisibility('actions')"><span [matBadge]="actionsCount" matBadgeSize="small"
                        matBadgeOverlap="false">{{'ACTIONS.ACTIONS' | translate}}</span></a>
                <a mat-button [routerLink]="'/incidents'" [routerLinkActive]="'active'" class="mx-2"><span
                        [matBadge]="(incidentsService.pendingIncidents$ | async)?.length || 0" matBadgeSize="small"
                        matBadgeOverlap="false">{{'ISSUE_REPORT' | translate}}</span></a>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>
    <div class="d-flex justify-content-end align-items-center header-container">
        <div class="user-email">{{currentUser?.email}}</div>

        <div ngbDropdown class="d-inline-block">
            <ng-container *ngIf="currentUser.picture && !notFoundImg; else noUserImg">
                <img src="{{ currentUser.picture }}" (error)="notFoundImgHandler($event)" alt="User profile" id="userDropdown" class="align-text-top user-actions" ngbDropdownToggle />
            </ng-container>
            <ng-template #noUserImg>
                <a type="button" class="btn user-actions" id="userDropdown" ngbDropdownToggle aria-label="Azioni utente"></a>
            </ng-template>
            <div ngbDropdownMenu aria-labelledby="userDropdown">
                <button ngbDropdownItem class="py-2 px-4" *ngIf="getVisibility('delegates')" [routerLink]="'/delegates'">
                    <fa-icon class="font-20 p-3 align-middle" [icon]="faUserGroup"></fa-icon>
                    <span class="pe-3 font-16">Delegates</span>
                </button>
                <div class="dropdown-divider" *ngIf="getVisibility('delegates')"></div>
                <button ngbDropdownItem class="py-2 px-4" (click)="logoutWithGoogle()">
                    <fa-icon class="font-25 p-3 align-middle" [icon]="faRightFromBracket"></fa-icon>
                    <span class="pe-3 font-16">Log out</span>
                </button>
            </div>
        </div>

        <fa-icon (click)="assistanceModal()" [icon]="faCircleQuestion" class="question-btn me-4"></fa-icon>
    </div>
</div>